export interface AirportContractListAdditionalFeeGetRecord {
  id: number;
  airportContractId: number;
  fuelFeeName: string;
  price: number;
  fuelFeeId?: number;
  feeUomCurrencyId?: number;
  feeUomUnitConverterId?: number;
  usdT?: number;
}
